// src/components/Filters/DietaryRestrictionsFilter.js
import React from 'react';
import { dietaryRestrictionsList } from '../../data/filterOptions';
import './FilterStyles.css';

const DietaryRestrictionsFilter = ({ selectedRestrictions, onChange }) => {
  const handleChange = (restrictionKey) => {
    const newSelectedRestrictions = { ...selectedRestrictions };
    newSelectedRestrictions[restrictionKey] = !newSelectedRestrictions[restrictionKey];
    onChange(newSelectedRestrictions);
  };

  return (
    <div className="filter-section">
      <h3>Dietary Restrictions</h3>
      <div className="filter-options-grid checkbox-grid-dietary">
        {dietaryRestrictionsList.map(({ key, label }) => (
          <label key={key} className="filter-option-label">
            <input
              type="checkbox"
              checked={selectedRestrictions[key] || false}
              onChange={() => handleChange(key)}
            />
            {label}
          </label>
        ))}
      </div>
    </div>
  );
};

export default DietaryRestrictionsFilter;
